export function formatToPercent(value: number): string {
  return (
    value
      .toFixed(2)
      .replace(".", ",")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".") + "%"
  );
}